export type ColorPropType = `#${string | number}`;

export const THEME = {
  LIGHT: 'light',
  DARK: 'dark',
  INHERIT: 'inherit',
} as const;

export type ThemeUnion = (typeof THEME)[keyof typeof THEME] | null;
